import { useWizard } from "react-use-wizard";
import AimStep from "../../../../../../../shared/wizard/steps/aimStep";
import buySteps from "../../buySteps";
import { TKeyOfDataWizardBuy, TStringKeysOfIFillDataWizardBuy } from "../../..";
import { EPurchasePurpose } from "../../../../../../../shared/wizard/steps/types";

interface ISelectionByOwnBuyStep_8 {
  isNextStepDisabled: boolean;
  onChange: (
    data: EPurchasePurpose,
    key: TStringKeysOfIFillDataWizardBuy
  ) => void;
  data: EPurchasePurpose | null;
  onReset: (key: TKeyOfDataWizardBuy[]) => void;
}

const SelectionByOwnBuyStep_8 = ({
  isNextStepDisabled,
  data,
  onChange,
  onReset,
}: ISelectionByOwnBuyStep_8) => {
  const { goToStep } = useWizard();

  const handlePrevStep = () => {
    goToStep(buySteps.selectionSteps.buy.step_7);
    onReset(["aim"]);
  };

  const handleNextStep = () => {
    goToStep(buySteps.selectionSteps.buy.step_9);
  };

  return (
    <div>
      <AimStep
        onNexStep={handleNextStep}
        onPrevStep={handlePrevStep}
        onChange={onChange}
        isNextStepDisabled={isNextStepDisabled}
        data={data}
      />
    </div>
  );
};

export default SelectionByOwnBuyStep_8;
